<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <shed-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></shed-add-form>
                <shed-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></shed-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import ShedAddForm from './forms/add/representations/WizardForm'
    import ShedUpdateForm from './forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../shedStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            ShedAddForm,
            ShedUpdateForm
        },

    }
</script>
